/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountTagKeyQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountTagKeyQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceAccountTagKeyQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountTagKeyQueryOperator>): ServiceAccountTagKeyQueryOperator {
        let obj = Object.assign(new ServiceAccountTagKeyQueryOperator(), model);
        ServiceAccountTagKeyQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountTagKeyQueryOperator>): ServiceAccountTagKeyQueryOperator {
        if (!model) return null;
        return ServiceAccountTagKeyQueryOperator.newInstance(<ServiceAccountTagKeyQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountTagKeyQueryOperator) {
        if (!obj) return;

        models.ServiceAccountTagKeyQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountTagKeyQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountTagKeyQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tag keys to include
     */
    tag_keys: Array<string>;

}
